import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Outlet } from 'react-router-dom';

import SignInPage from './SignIn';

export const LoginRequired = () => {
  return (
    <>
      <SignedIn>
        <Outlet />
      </SignedIn>
      <SignedOut>
        <SignInPage />
      </SignedOut>
    </>
  );
};
